import React, { useEffect, useState } from 'react';
import { ArrayItem, FormState } from './constants';

interface PreviewTemplateProps {
    formState: FormState;
}

const PreviewTemplate: React.FC<PreviewTemplateProps> = ({ formState }) => {
    const [validatedFieldsBody, setValidatedFieldsBody] = useState<any>([]);
    const [validatedFieldsTable, setValidatedFieldsTable] = useState<any>([]);

    const filterDataBody = () => {
        const tempArray = formState.ArrayBody.filter((field: ArrayItem) => field.Visible);
        setValidatedFieldsBody(tempArray);
    };
    const filterDataTable = () => {
        const tempArray = formState.ArrayTable.filter((field: ArrayItem) => field.Visible);
        setValidatedFieldsTable(tempArray);
    };

    useEffect(() => {
        filterDataBody();
        filterDataTable();
    }, [formState]);

    const getbrand = localStorage.getItem('brand');
    let client;
    if (getbrand) {
        client = JSON.parse(getbrand);
    }

    return (
        <div className="body">
            <style>{`
            .body {
              font-family: Arial, Helvetica, sans-serif;
              margin: 20px;
              font-size: 110%;
              color: black;
              border: 1px solid grey;
            }
            .Logo {
              height: 120px;
            }
            .Logo2 {
              height: 70px;
            }
            .signature {
              height: 80px;
              margin-top: 0px;
            }
            .SignatureName {
              margin-top: 0px;
            }
            .centerText {
              text-align: center;
              margin-top: 40px;
            }
            .centerTextDate {
              text-align: center;
              margin-top: 40px;
            }
            .titleList {
              font-weight: 300;
            }
            table {
              width: 95%;
              border-collapse: collapse;
              margin: 20px auto;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
            .flex {
              height: 150px;
              display: flex;
              justify-content: space-between;
            }
            .Flex {
              display: flex;
              justify-content: center;
              margin: 10px;
            }
            .Column {
              display: flex;
              flex-direction: column;
              text-align: center;
              margin: 0 20px 0 20px;
            }
            .ContenedorLogo {
              display: flex;
              height: 100%;
              justify-content: center;
              align-items: center;
              margin: 0 20px 0 100px;
            }
            .TStrart {
              align-items: start;
            }
            .ContenedorLogoEnd {
              height: 100%;
              justify-content: end;
              align-items: start;
              margin: 0 10px 0 50px;
            }
            .AlignStart {
              align-items: start;
              margin: 0;
            }
            .ContenedorP {
              height: 150px;
              border-top: 1px solid rgb(60, 113, 159);
              border-bottom: 1px solid rgb(60, 113, 159);
              margin: 20px;
              display: grid;
              grid-template-columns: auto auto auto;
            }
            .GRID {
              margin: 20px;
              display: grid;
              grid-template-columns: 20% 20% 20% 20% 20%;
            }
            .GRID p {
              margin: 5px;
            }
            .Contenido {
              height: 250px;
            }
            .Total {
              height: 140px;
              border-top: 1px solid rgb(60, 113, 159);
              border-bottom: 1px solid rgb(60, 113, 159);
              margin: 20px;
              display: grid;
              grid-template-columns: 60% 40%;
            }
            .blue {
              color: rgb(60, 113, 159);
            }
            .Totales {
              width: 100%;
              flex-direction: column;
              text-align: start;
              align-items: end;
              justify-content: end;
              margin-top: 10px;
            }
            .Cuadro {
              height: 100px;
              border: 2px solid black;
            }
            .CuadroSignature {
              height: 100px;
              border: 2px solid black;
              text-align: center;
            }
            .ContenedorCuadro {
              display: flex;
              flex-direction: column;
              justify-content: start;
              text-align: start;
            }
            .Cuadros {
              margin: 20px;
              display: grid;
              grid-template-columns: 1fr 1fr;
              column-gap: 20px;
            }
            .TextBottom {
              text-align: center;
              margin: 50px 20px 0px 0px;
              grid-column: span all;
              grid-column-start: 1;
              grid-column-end: -1;
            }
            .textPOD {
              color: #00AAE4;
              font-size: 100px;
              font-weight: bold;
            }
          `}</style>

            <div className="flex">
                <div className="ContenedorLogo">{formState.ShowLogo && <img className="Logo" src={client.logo ?? ''} alt="logoClient" />}</div>
                <div className="Column">
                    <h4>TEST AGENT</h4>
                    <p>
                        <b>123 NW 456 Ave</b>
                        <br />
                        <b>Cartagena</b>
                        <br />
                        <b>Colombia</b>
                        <br />
                        <b>3131323223</b>
                    </p>
                </div>
                <div className="ContenedorLogoEnd Column TStrart">{formState.ShowPODtext && <h1 className="textPOD">POD</h1>}</div>
            </div>

            <div className="ContenedorP">
                <div className="AlignStart">
                    {formState.Consignee_Visible && (
                        <p className="titleList">
                            <strong>{formState.Consignee_DisplayText}</strong>
                            <h5>Storage Customer</h5>
                            <b>123 NW 456 Ave</b>
                            <br />
                            <b>Argentina</b>
                            <br />
                            <b>Buenos Aires</b>
                            <br />
                            <b>3131323223</b>
                        </p>
                    )}
                    {formState.ReleasedTo_Visible && (
                        <p className="titleList">
                            <strong>{formState.ReleasedTo_DisplayText}</strong>
                            <h5>Storage Customer</h5>
                            <b>123 NW 456 Ave</b>
                            <br />
                            <b>Argentina</b>
                            <br />
                            <b>Buenos Aires</b>
                            <br />
                            <b>3131323223</b>
                        </p>
                    )}
                </div>
                <div className="Flex">
                    {formState.DriverName_Visible && (
                        <h4>
                            {formState.DriverName_DisplayText}: <b>Example Data</b>
                        </h4>
                    )}
                </div>
            </div>

            <div className="Contenido">
                <div className="GRID">
                    {validatedFieldsBody.map((field: any, index: any) => (
                        <p key={index} className="titleList">
                            {field.DisplayText}:<br />
                            <span style={{ fontWeight: 'bold' }}>{field.Property}</span>
                        </p>
                    ))}
                </div>
                <table>
                    <thead>
                        <tr>
                            {validatedFieldsTable.map((field: any, index: any) => (
                                <th key={index}>{field.DisplayText}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {validatedFieldsTable.map((field: any, index: any) => (
                                <td key={index}>{field.Property}</td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="Total">
                <h2 className="blue">Totals</h2>
                <div className="Totales">
                    <h3>
                        <b className="blue">Total Pieces: </b> 1144 PCS
                    </h3>
                    <h3>
                        <b className="blue">Total Gross Weight: </b> 0.000 Kg
                    </h3>
                    <h3>
                        <b className="blue">Total Vol Weight: </b> 548.571 vkg
                    </h3>
                </div>
            </div>

            <div className="Cuadros">
                <div className="ContenedorCuadro">
                    <h3>Signature & Name</h3>
                    <div className="CuadroSignature">
                        <img className="signature" src="https://innobo9aee.blob.core.windows.net/innobofiles/178/FIRMA%20ejemplo.avifID178.avif" alt="signature" />
                        <h5 className="SignatureName">HARDWOODS INC</h5>
                    </div>
                </div>
                <div className="ContenedorCuadro">
                    <h3>Date & Time:</h3>
                    <div className="Cuadro">
                        <h3 className="centerTextDate">05/08/2024 - 18:33:29</h3>
                    </div>
                </div>
                <div className="ContenedorCuadro">
                    <h3>Notes:</h3>
                    <div className="Cuadro">
                        <p className="centerText">TEST POD 05/08/24</p>
                    </div>
                </div>
                <div className="ContenedorCuadro">
                    <h3>Executed By:</h3>
                    <div className="Cuadro">
                        <p className="centerText">Andrés from Innobo</p>
                    </div>
                </div>
            </div>

            <div className="TextBottom">{formState.Footer && <p>{formState.Footer}</p>}</div>
        </div>
    );
};

export default PreviewTemplate;
